var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-progress"},[_c('div',{staticClass:"wizard-progress__label"},[_vm._v("Step "+_vm._s(_vm.current)+" of "+_vm._s(_vm.total))]),_c('div',{staticClass:"wizard-progress__bar"},[_c('div',{staticClass:"wizard-progress__fill",style:({ width: _vm.pct + '%' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }